import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MatFormFieldModule } from "@angular/material/form-field";
import { RelocationReferralPopupComponent } from '../relocation-referral-popup/relocation-referral-popup.component';
import { ServiceChangeRequestService } from 'src/app/services/service-change-request.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-relocation-promotion',
  templateUrl: './relocation-promotion.component.html',
  styleUrls: ['./relocation-promotion.component.scss'],

})
export class RelocationPromotionComponent implements OnInit {
  form: FormGroup;
  customerReferenceNumber: string;
  relocationPromotionLink: any;
  constructor(
    private fb: FormBuilder,
    private matdialog: MatDialog,
    private serviceChangeRequestService: ServiceChangeRequestService,
    private toastr: ToastrService,
    private navigation: NavigationService
  ) {
    this.initializeValidators();
  }

  ngOnInit(): void {
  }

  initializeValidators() {
    this.form = this.fb.group({
      customerNumber: ['', [Validators.required, Validators.minLength(4), Validators.pattern(/^(?!\s*$).+/)]] ,
    })
  }

  generateLink() {
    debugger
    if (this.form.valid) {
      this.customerReferenceNumber = this.form.value.customerNumber;
      this.serviceChangeRequestService.generateLinkRetentionPromotion(this.customerReferenceNumber).subscribe(
        (res: any) => {
          if (res) {
            this.relocationPromotionLink = res
            this.sendLink();
          }
        })
    }
    else {
      this.toastr.error("Please enter the Customer Number")
    }
  }

  sendLink() {
    const dialogref = this.matdialog.open(RelocationReferralPopupComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'mat-dialog',
      width: "40%",
      data: {
        head: 'Retention Referral',
        data: this.relocationPromotionLink
      }
    });
    // dialogref.afterClosed().subscribe((result) => {
    //   console.log(result)
    //   if (result) {
    //   }
      
    // })
  }

  goBack() {
    this.navigation.goTomanageRelocationPromotion();
  }
}